import LogRocket from 'logrocket';
import setupLogRocketReact from 'logrocket-react';

// only initialize when in the browser
if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_LOGROCKET_APP_ID) {
  LogRocket.init(process.env.NEXT_PUBLIC_LOGROCKET_APP_ID);
  // plugins should also only be initialized when in the browser
  setupLogRocketReact(LogRocket);
}
